import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { VentaService } from '../../../services/venta.service';
import { Venta } from './../../../models/venta';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Pagination } from '../../../models/pagination';

@Component({
  selector: 'app-venta-nota-modal',
  templateUrl: './venta-nota-modal.component.html',
  styleUrls: ['./venta-nota-modal.component.css'],
  providers: [VentaService]

})
export class VentaNotaModalComponent implements OnInit {

  @Output() onSelectedRow = new EventEmitter();
	@Input() qs = "";
	@Input() numero_decimales: number = 2;
	public ventas: Array<Venta> = [];
	public selectedRow: Number;
	public venta: Venta;
	public pagination: Pagination;
	public loading = false;
	public format_decimal: String;

	constructor(
		public VentaService: VentaService,
		public bsModalRef: BsModalRef,
	) {
		this.ventas = [];
		this.venta = new Venta();
		this.pagination = new Pagination();
		this.format_decimal = "0,0.00";
    }

	ngOnInit() {
		let digitos = "";
		for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
		this.format_decimal = "0,0." + digitos;

		this.getVentas();
	}

	getVentasBySearch(text){
		let qs = "&razon_social="+text+"&nombre_comercial="+text+"&total="+text+"&fecha_emision="+text;
		this.pagination.current_page = 1;
		this.getVentas(qs);
	}

	getVentas(qs = ""){
		this.loading = true;
		this.VentaService.getAllByNotas("?page="+this.pagination.current_page+"&per_page=10&tipo=V"+qs).subscribe(
			res => {
				this.loading = false;
				this.ventas = res.data;
				this.pagination.current_page = res.current_page;
				this.pagination.from = res.from;
				this.pagination.to = res.to;
				this.pagination.total = res.total;
				this.pagination.last_page = res.last_page;
				this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
				this.pagination.prev_disabled = this.pagination.current_page === 1;
			},
			err => {
				this.loading = false;
				this.ventas = [];
			}
		);
	}

	numeroFactura(venta){
        return venta.serie + "-" + venta.punto_emision + "-" + venta.secuencial;
	}
	
	parseTipo(tipo){
		if( tipo === "CR" ){
			return "Crédito";
		}else{
			return "Contado";
		}
	}

	onSelectRow(venta, i) {
		//Asignacion de fila
		this.selectedRow = i;
		//Asignacion de usuario
		this.venta = venta;
	}

	onDBLClick(usuario,i){
		this.onSelectRow(usuario,i);
		this.onSubmit();
	}

	onSubmit() {
		//envía de objecto usuario
		this.onSelectedRow.emit(this.venta);
		//Cierre de modal o componente
		this.bsModalRef.hide();
	}

	next(){
		this.pagination.current_page++;
		this.getVentas();
	}

	prev(){
		this.pagination.current_page--;
		this.getVentas();
	}

	first(){
		this.pagination.current_page = 1;
		this.getVentas();
	}

	last(){
		this.pagination.current_page = this.pagination.last_page;
		this.getVentas();
	}

	get formatDecimal(){
    return this.format_decimal;
  }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/venta-nota-modal/venta-nota-modal.component.ts